module.exports = __webpack_public_path__ + "static/media/service_roadmap.2687dd87.png";